
<div class="hbox">
  <div class="flex-box">
    <div class="flex-heading">
      <div class="col-xs-12 list-header" *ngIf="!hideHeader">
        <ul class="breadcrumb">
          <li><a routerLink="/products/regimens" href="/products/regimens">Regimens</a></li>
          <li>{{regimenObj?.id ? 'Edit' : 'New' }}</li>
        </ul>
        <div class="pull-right flex">
          <button class="done-finish-button btn-xs ml-3" *ngIf="showAsOfflineRegimen" [disabled]="!canDoctorApproveRegimen" (click)="approveRegimen()">Approve Regimen</button>
          <div class="flex px-3" *ngIf="!showAsOfflineRegimen">
            <button class="btn-xs" (click)="changeVariant(this.appConfig.Shared.Regimen.Variants.VariantId.variant_1499)" [ngClass]="{'btn-primary': currentVariantId == this.appConfig.Shared.Regimen.Variants.VariantId.variant_1499, 'btn-primary-outline': currentVariantId !== this.appConfig.Shared.Regimen.Variants.VariantId.variant_1499 }">variant1</button>
            <button class="btn-xs ml-3" (click)="changeVariant(this.appConfig.Shared.Regimen.Variants.VariantId.variant_1999)" [ngClass]="{'btn-primary': currentVariantId == this.appConfig.Shared.Regimen.Variants.VariantId.variant_1999, 'btn-primary-outline': currentVariantId !== this.appConfig.Shared.Regimen.Variants.VariantId.variant_1999 }">variant2</button>
            <button class="btn-xs ml-3" (click)="changeVariant(this.appConfig.Shared.Regimen.Variants.VariantId.variant_4999)" [ngClass]="{'btn-primary': currentVariantId == this.appConfig.Shared.Regimen.Variants.VariantId.variant_4999, 'btn-primary-outline': currentVariantId !== this.appConfig.Shared.Regimen.Variants.VariantId.variant_4999 }">variant3</button>
            <button class="btn-xs ml-3" (click)="changeVariant(this.appConfig.Shared.Regimen.Variants.VariantId.variant_999)" [ngClass]="{'btn-primary': currentVariantId == this.appConfig.Shared.Regimen.Variants.VariantId.variant_999, 'btn-primary-outline': currentVariantId !== this.appConfig.Shared.Regimen.Variants.VariantId.variant_999 }">variant4</button>
          </div>
          <button class="btn-xs btn-primary-outline ml-2" *ngIf="!showAsOfflineRegimen" (click)="openRegimenProductChangeHistory()">Product History</button>
        </div>
      </div>
    </div>
    <div class="flex-content col-xs-12 p-0" [ngClass]="{'opacity': ui.makeBlur }">
      <div class="col-xs-12 flex" *ngIf="currentVariantId">
        <label class="col-xs-2">Disable</label>
        <div class="col-xs-1">:</div>
        <div class="flex">
          <label class="i-switch i-switch-sm ml-2">
            <input type="checkbox" [(ngModel)]="disableVariant" name="disableVariant" (ngModelChange)="updateVariantIsDisable()"/><i></i>
          </label>
          <div innerHTML="disable"></div>
        </div>
      </div>
      <form class="col-xs-12 p-4" #regimenForm="ngForm">
        <div class="form-group col-xs-12" *ngIf="regimenObj && !disableVariant">
          <div class="col-xs-12 text-danger text-center p-2" *ngIf="![apiClientConstant.Regimen.Type.PERSONALIZED].includes(regimenObj.get('type'))">This is regimen template, editing this will change regimen for all users.</div>
          <div class="col-xs-12 flex alignFS" *ngIf="showAsOfflineRegimen">
            <div class="col-xs-4">
              <div class="heading bg-white">
                <div class="flex">
                  <label>chat view</label>
                  <label class="i-switch i-switch-sm bg-success ml-3">
                    <input type="checkbox" [(ngModel)]="selectChat" (ngModelChange)="changeSelectedChatType(selectChat)" name="selectedChatType"/><i></i>
                  </label>
                </div>
              </div>
              <user-chat-view-human-interaction *ngIf="selectedChatType === 'userChat'" [privateMainConcernClass]="regimenObj.get('class')" [user]="regimenObj.get('forUser')" [height]="'100%'"></user-chat-view-human-interaction>
              <user-chat-view-summary [user]="regimenObj.get('forUser')" *ngIf="selectedChatType === 'chatSummary'" [regimenClass]="regimenObj?.get('class')" [fromNewOrderApprovalPage]="true" [isProductOrder]="false" [isOfflineRegimen]="showAsOfflineRegimen" [patientName]="patientName"></user-chat-view-summary>
            </div>
            <div class="col-xs-6 flex-grow">
              <instant-checkup-magnifier [user]="regimenObj.get('forUser')" (needHelpButtonClicked)="markOrderWaitingForImageNew()"></instant-checkup-magnifier>
            </div>
          </div>
          <div class="col-xs-12 flex">
            <div class="col-xs-5 mr-3 flex-grow">
              <label class="col-xs-4">Regimen Id</label>
              <div class="col-xs-12">
                <input-text [parseObj]="regimenObj" name="regimenId" [required]="true" placeholder="{{regimenObj.get('regimenId') || 'Id'}}" [disabled]="regimenObj?.id || regimenObj.get('type') === apiClientConstant.Regimen.Type.ALTERNATE"></input-text>
              </div>
              <div class="col-xs-12" *ngIf="[apiClientConstant.Regimen.Type.PERSONALIZED].includes(regimenObj.get('type'))">
                <div class="col-xs-10">
                  <input class="form-control" [(ngModel)]="copyFromRegimenId" name="copyFromRegimenId" placeholder="Copy regimen from id"/>
                </div>
                <div class="col-xs-2"><i class="fa fa-copy pointer m-t-xs" style="font-size:1.5em;" (click)="copyRegimen()"></i></div>
              </div>
            </div>
            <div class="col-xs-6">
              <language-string-multiple-selection [parseObj]="regimenObj" name="concernsLanguageString" title="Display Concern" (onChangeEditReasonRegimenSOP)="updateRegimenEditReason()" [required]="true" [tags]="['concern','display']"></language-string-multiple-selection>
            </div>
          </div>
          <div class="col-xs-12 p0" *ngIf="!fromOrderApproval">
            <div class="col-xs-12">
              <label class="col-xs-4">Title</label>
              <div class="col-xs-12">
                <input-text [parseObj]="regimenObj" name="title" placeholder="Title"></input-text>
              </div>
            </div>
            <div class="col-xs-12">
              <label class="col-xs-4">Class</label>
              <div class="col-xs-12">
                <input-select [parseObj]="regimenObj" name="class" [required]="true" [options]="regimenClasses"></input-select>
              </div>
            </div>
            <div class="col-xs-12 mt-4" *ngIf="currentVariantId === this.appConfig.Shared.Regimen.Variants.VariantId.variant_1499">
              <language-string-tag-selection [parseObj]="regimenObj" name="tags"></language-string-tag-selection>
            </div>
            <div class="col-xs-12 mt-3 p-3" style="border: 1px solid #ddd; border-radius: 4px; background: #f9f9f9;">
              <h4 style="cursor: pointer; user-select: none;" (click)="showDisplayConcern = !showDisplayConcern">
                {{showDisplayConcern ? '&#9660;' : '&#9654;'}} Display Concern
              </h4>
              <div *ngIf="showDisplayConcern">
                <div class="col-xs-12 mt-2">
                  <label class="col-xs-4">Treatment Concern (Primary)</label>
                  <div class="col-xs-12">
                    <select class="bdr form-control" name="primaryTreatmentConcern" [(ngModel)]="primaryTreatmentConcern" (ngModelChange)="onTreatmentConcernChange()">
                      <option value="">-- Select --</option>
                      <option *ngFor="let option of treatmentConcernsOptions" [value]="option.value">{{option.display}}</option>
                    </select>
                  </div>
                </div>
                <div class="col-xs-12 mt-2">
                  <label class="col-xs-4">Treatment Concern (Secondary)</label>
                  <div class="col-xs-12">
                    <select class="bdr form-control" name="secondaryTreatmentConcern" [(ngModel)]="secondaryTreatmentConcern" (ngModelChange)="onTreatmentConcernChange()">
                      <option value="">-- Select --</option>
                      <option *ngFor="let option of treatmentConcernsOptions" [value]="option.value">{{option.display}}</option>
                    </select>
                  </div>
                </div>
                <div class="col-xs-12 mt-2">
                  <label class="col-xs-4">Name (Language String)</label>
                  <div class="col-xs-12">
                    <language-string-selection [parseObj]="regimenObj.get('displayConcern')" name="nameLanguageString" [tags]="['regimen','name']"></language-string-selection>
                  </div>
                </div>
                <div class="col-xs-12 mt-2">
                  <label class="col-xs-4">Severity (Language String)</label>
                  <div class="col-xs-12">
                    <language-string-selection [parseObj]="regimenObj.get('displayConcern')" name="severityLanguageString" [tags]="['regimen','severity']"></language-string-selection>
                  </div>
                </div>
                <div class="col-xs-12 mt-2">
                  <label class="col-xs-4">Other Goals (Language String)</label>
                  <div class="col-xs-12">
                    <language-string-selection [parseObj]="regimenObj.get('displayConcern')" name="otherGoalsLanguageString" [tags]="['regimen','other_goals']"></language-string-selection>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 mt-3 p-3" style="border: 1px solid #ddd; border-radius: 4px; background: #f9f9f9;" *ngIf="regimenObj.get('class') !== 'HAIR'">
              <h4 style="cursor: pointer; user-select: none;" (click)="showSkinReportParams = !showSkinReportParams">
                {{showSkinReportParams ? '&#9660;' : '&#9654;'}} Skin Report Params
              </h4>
              <div *ngIf="showSkinReportParams">
                <div class="col-xs-12 mt-3">
                  <label class="col-xs-12"><strong>Skin Parameters</strong></label>
                </div>
                <div class="col-xs-12 mt-2" *ngFor="let param of skinParameterConfig">
                  <div class="col-xs-12 flex" style="align-items: center;">
                    <label class="col-xs-3">{{param.label}}</label>
                    <div class="col-xs-3">
                      <input type="number" class="bdr form-control" [name]="'score_' + param.key" [(ngModel)]="skinParameterScores[param.key]" (ngModelChange)="onSkinReportParamsChange()" placeholder="Patient Score" min="0">
                    </div>
                    <div class="col-xs-3 ml-2" *ngIf="param.expectedRange">
                      <span class="text-muted">Expected Range: <strong>{{param.expectedRange}}</strong></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 mt-3 p-3" style="border: 1px solid #ddd; border-radius: 4px; background: #f9f9f9;" *ngIf="regimenObj.get('class') === 'HAIR'">
              <h4 style="cursor: pointer; user-select: none;" (click)="showHairReportParams = !showHairReportParams">
                {{showHairReportParams ? '&#9660;' : '&#9654;'}} Hair Report Params
              </h4>
              <div *ngIf="showHairReportParams">
                <div class="col-xs-12 mt-3">
                  <label class="col-xs-12"><strong>Hair Parameters</strong></label>
                </div>
                <div class="col-xs-12 mt-2" *ngFor="let param of hairParameterConfig">
                  <div class="col-xs-12 flex" style="align-items: center;">
                    <label class="col-xs-3">{{param.label}}</label>
                    <div class="col-xs-3">
                      <input type="number" class="bdr form-control" [name]="'hair_score_' + param.key" [(ngModel)]="hairParameterScores[param.key]" (ngModelChange)="onHairReportParamsChange()" placeholder="Patient Score" min="0">
                    </div>
                    <div class="col-xs-3 ml-2" *ngIf="param.expectedRange">
                      <span class="text-muted">Expected Range: <strong>{{param.expectedRange}}</strong></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 mt-3 p-3" style="border: 1px solid #ddd; border-radius: 4px; background: #f9f9f9;">
              <h4 style="cursor: pointer; user-select: none;" (click)="showExtraRegimenInfo = !showExtraRegimenInfo">
                {{showExtraRegimenInfo ? '&#9660;' : '&#9654;'}} Extra Regimen Info
              </h4>
              <div *ngIf="showExtraRegimenInfo">
                <div class="col-xs-12 mt-2">
                  <label class="col-xs-3">Pregnancy</label>
                  <div class="col-xs-4">
                    <select class="bdr form-control" name="extraPregnancy" [(ngModel)]="extraRegimenInfo.pregnancy" (ngModelChange)="onExtraRegimenInfoChange()">
                      <option value="">-- Select --</option>
                      <option *ngFor="let option of pregnancyOptions" [value]="option.value">{{option.display}}</option>
                    </select>
                  </div>
                </div>
                <div class="col-xs-12 mt-2">
                  <label class="col-xs-3">Hormonal Impact</label>
                  <div class="col-xs-4">
                    <select class="bdr form-control" name="extraHormonalImpact" [(ngModel)]="extraRegimenInfo.hormonalImpact" (ngModelChange)="onExtraRegimenInfoChange()">
                      <option value="">-- Select --</option>
                      <option *ngFor="let option of hormonalImpactOptions" [value]="option.value">{{option.display}}</option>
                    </select>
                  </div>
                </div>
                <div class="col-xs-12 mt-2">
                  <label class="col-xs-3">Age</label>
                  <div class="col-xs-4">
                    <select class="bdr form-control" name="extraAge" [(ngModel)]="extraRegimenInfo.age" (ngModelChange)="onExtraRegimenInfoChange()">
                      <option value="">-- Select --</option>
                      <option *ngFor="let option of ageOptions" [value]="option.value">{{option.display}}</option>
                    </select>
                  </div>
                </div>
                <div class="col-xs-12 mt-2">
                  <label class="col-xs-3">Sensitive Skin</label>
                  <div class="col-xs-4">
                    <select class="bdr form-control" name="extraSensitiveSkin" [(ngModel)]="extraRegimenInfo.sensitiveSkin" (ngModelChange)="onExtraRegimenInfoChange()">
                      <option value="">-- Select --</option>
                      <option *ngFor="let option of sensitiveSkinOptions" [value]="option.value">{{option.display}}</option>
                    </select>
                  </div>
                </div>
                <div class="col-xs-12 mt-2">
                  <label class="col-xs-3">Steroid Abuse</label>
                  <div class="col-xs-4">
                    <select class="bdr form-control" name="extraSteroidAbuse" [(ngModel)]="extraRegimenInfo.steroidAbuse" (ngModelChange)="onExtraRegimenInfoChange()">
                      <option value="">-- Select --</option>
                      <option *ngFor="let option of steroidAbuseOptions" [value]="option.value">{{option.display}}</option>
                    </select>
                  </div>
                </div>
                <div class="col-xs-12 mt-2">
                  <label class="col-xs-3">Gender</label>
                  <div class="col-xs-4">
                    <select class="bdr form-control" name="extraGender" [(ngModel)]="extraRegimenInfo.gender" (ngModelChange)="onExtraRegimenInfoChange()">
                      <option value="">-- Select --</option>
                      <option *ngFor="let option of genderOptions" [value]="option.value">{{option.display}}</option>
                    </select>
                  </div>
                </div>
                <div class="col-xs-12 mt-2">
                  <label class="col-xs-3">Expected Timeline</label>
                  <div class="col-xs-4">
                    <select class="bdr form-control" name="extraExpectedTimeline" [(ngModel)]="extraRegimenInfo.expectedTimeline" (ngModelChange)="onExtraRegimenInfoChange()">
                      <option value="">-- Select --</option>
                      <option *ngFor="let option of expectedTimelineOptions" [value]="option.value">{{option.display}}</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xs-12 mt-3 p-3" style="border: 1px solid #ddd; border-radius: 4px; background: #f9f9f9;">
              <h4 class="mb-3">Overall Summary</h4>
              <div class="col-xs-12 mt-2">
                <label class="col-xs-4">Overall Summary (Language String)</label>
                <div class="col-xs-12">
                  <language-string-selection [parseObj]="regimenObj" name="overallSummary" [tags]="['regimen','overall_summary']" [showSearch]="true"></language-string-selection>
                </div>
              </div>
              <div class="col-xs-12 mt-3">
                <button type="button" class="btn btn-sm btn-primary" (click)="generateOverallSummary()">Generate Summary Text</button>
                <button type="button" class="btn btn-sm btn-success ml-2" (click)="generateOverallSummaryHindi()">Generate Hindi Summary</button>
              </div>
              <div class="col-xs-12 mt-2" *ngIf="generatedSummaryText">
                <label class="col-xs-12 mb-1"><strong>Generated Text (copy this to create a Language String):</strong></label>
                <div class="col-xs-12 p-2" style="background: #fff; border: 1px solid #ccc; border-radius: 4px; white-space: pre-wrap;">{{generatedSummaryText}}</div>
              </div>
              <div class="col-xs-12 mt-2" *ngIf="generatedHindiSummaryText">
                <label class="col-xs-12 mb-1"><strong>Generated Hindi Text (editable):</strong></label>
                <textarea class="col-xs-12 form-control" rows="4" [(ngModel)]="generatedHindiSummaryText" name="generatedHindiSummaryText"></textarea>
                <button type="button" class="btn btn-sm btn-success mt-2" (click)="applyHindiSummaryToLanguageString()">Apply Hindi to LanguageString</button>
              </div>
              <div class="col-xs-12 mt-2" *ngIf="hindiSummaryStatus">
                <div class="col-xs-12 p-2" style="background: #e8f5e9; border: 1px solid #a5d6a7; border-radius: 4px;">{{hindiSummaryStatus}}</div>
              </div>
            </div>
            <div class="col-xs-12 flex" *ngIf="regimenObj?.id">
              <div class="col-xs-4">
                <label class="col-xs-4">Update Regimen Cover image</label>
                <div class="col-xs-12 mt-2" *ngIf="!!regimenObj.get('regimenCoverImage')"><img style="padding-left:15px" height="150px" widht="150px" src="{{regimenObj.get('regimenCoverImage')}}"/></div>
                <div class="col-xs-12 m-4">
                  <button (click)="openMediaLinkEditForCurrentProducts()">update</button>
                </div>
              </div>
            </div>
            <div class="col-xs-12" *ngIf="currentVariantId && currentVariantId !== this.appConfig.Shared.Regimen.Variants.VariantId.variant_1499">
              <button (click)="copyRegimenFromRegimen(regimenObjVariant1)">copy from variant1</button>
              <button class="ml-3" *ngIf="currentVariantId === this.appConfig.Shared.Regimen.Variants.VariantId.variant_4999" (click)="copyRegimenFromRegimen(regimenObjVariant2)">copy from variant2</button>
              <button class="ml-3" *ngIf="currentVariantId !== this.appConfig.Shared.Regimen.Variants.VariantId.variant_1499" (click)="copyRegimenFromRegimen(regimenObjVariant3)">copy from variant3</button>
            </div>
          </div>
          <div class="col-xs-12 p-0 mt-3 flex alignFS">
            <div class="col-xs-6 product-morning-view">
              <regimen-edit-part-of-day [parseObj]="regimenObj" name="morning" title="Morning" (onProductUpdateRegimenEditReason)="updateRegimenEditReason()" (onProductUpdate)="onProductUpdate($event)" [hideNotNecessaryThings]="hideNotNecessaryThings" [reset]="changeMorningProducts" [variant]="currentVariantId"></regimen-edit-part-of-day>
            </div>
            <div class="col-xs-6 product-night-view mr-0">
              <regimen-edit-part-of-day [parseObj]="regimenObj" name="night" title="Night" (onProductUpdateRegimenEditReason)="updateRegimenEditReason()" (onProductUpdate)="onProductUpdate($event)" [hideNotNecessaryThings]="hideNotNecessaryThings" [reset]="changeNightProducts" [variant]="currentVariantId"></regimen-edit-part-of-day>
            </div>
          </div>
          <div class="col-xs-12">
            <label class="col-xs-4">Diet And Lifestyle</label>
            <div class="col-xs-12">
              <input-select [parseObj]="regimenObj" name="dietAndLifestyleQuestion" [options]="dietAndLifestyleList"></input-select>
            </div>
          </div>
          <div class="col-xs-12 mt-3">
            <label class="col-xs-4">Investigation</label>
            <div class="col-xs-12 mb-2">
              <input type="text" placeholder="Search investigation by name..." class="form-control" autocomplete="off"
                     [formControl]="autoCompleteInvestigation" [matAutocomplete]="investigationAuto">
              <mat-autocomplete #investigationAuto="matAutocomplete">
                <mat-option *ngFor="let option of investigationOptions | async" [value]="option.name"
                            (onSelectionChange)="onInvestigationSelect(option)">
                  {{option.name}}
                </mat-option>
              </mat-autocomplete>
            </div>
            <div class="col-xs-12 flex" *ngIf="selectedInvestigation">
              <strong class="mr-2">{{selectedInvestigation.get('name')}}</strong>
              <i class="fa fa-times pointer" (click)="clearInvestigation()"></i>
            </div>
            <ul class="col-xs-12 mt-1 pl-4" *ngIf="selectedInvestigation">
              <li *ngFor="let test of selectedInvestigation.get('tests')">{{test.test}}</li>
            </ul>
          </div>
          <div class="col-xs-12" [formGroup]="progressiveInfoForm">
            <h4>Select Progressive Info Product</h4>
            <div class="col-xs-12 mb-3">
              <input type="text" placeholder="Enter product name" class="form-control" autocomplete="off"
                     [formControl]="autoCompleteProgessiveInfo" title="Product Name"
                     [matAutocomplete]="progressiveInfoAuto" (input)="onProgressiveInfoInputChange($event)">
              <mat-autocomplete class="search-bar-xs" #progressiveInfoAuto="matAutocomplete">
                <mat-option *ngFor="let option of progressiveInfoProducts | async" [value]="option.name"
                            (onSelectionChange)="autoCompleteProgressiveInfoOnSelect(option)">
                  {{option.name}}
                </mat-option>
              </mat-autocomplete>
            </div>

            <div class="col-xs-12 flex mb-3">
              <div class="col-xs-3 mr-3">
                <label for="progressiveInfoAction">Action</label>
                <select class="form-control" id="progressiveInfoAction" formControlName="action">
                  <option *ngFor="let action of progressiveInfoActions" [value]="action.value">
                    {{action.displayName}}
                  </option>
                </select>
              </div>

              <div class="col-xs-4 mr-2 items-center">
                <label for="startAfterDayOfDelivery">Start After Day Of Delivery:</label>
                <input type="number" class="form-control" id="startAfterDayOfDelivery" min="1"
                       formControlName="startAfterDayOfDelivery" placeholder="Start After Day Of Delivery">
              </div>

              <div class="col-xs-4 mr-2 items-center">
                <label for="endAfterDayOfDelivery">End After Day Of Delivery:</label>
                <input type="number" class="form-control" id="endAfterDayOfDelivery" min="1"
                       formControlName="endAfterDayOfDelivery" placeholder="End After Day Of Delivery">
              </div>
            </div>

            <div *ngIf="showProgressiveProductInfo && !progressiveInfoInstructionLoading && progressiveInfoForm.get('product').value" class="col-xs-12 flex">
              <div *ngIf="!progressiveInfoForm.get('availableInstructions').value?.length">
                No instructions available for this product.
              </div>
              <div *ngIf="progressiveInfoForm.get('availableInstructions').value?.length" class="col-xs-6 mr-4" formGroupName="productInfo">
                <label for="progressiveInfoProductInstruction">Product Instruction</label>
                <select name="progressiveInfoProductInstruction" required="required"
                        (change)="onProgressiveInfoProductInstructionChange($event)"
                        formControlName="instruction" class="form-control">
                  <option *ngFor="let instruction of progressiveInfoForm.get('availableInstructions').value"
                          [value]="instruction.value">
                    {{instruction.display}}
                  </option>
                </select>

                <div class="r-2x wrapper-xs mt-2">
                  <language-view
                    *ngIf="progressiveInfoProductObj && progressiveInfoProductObj?.get('purposeDescriptionLanguageString')"
                    [languageStringObj]="progressiveInfoProductObj?.get('purposeDescriptionLanguageString')">
                  </language-view>
                </div>

                <div class="inline-flex pl-4 mt-3">
                  <label class="bold">OnHold</label>
                  <label class="i-switch i-switch-sm bg-secondary ml-2">
                    <input type="checkbox" formControlName="onHold" (change)="showAlertToChangeInstruction()"/><i></i>
                  </label>
                </div>
              </div>

              <div *ngIf="progressiveInfoForm.get('availableInstructions').value?.length" class="col-xs-6">
                <catalog-instruction-view [instruction]="progressiveInfoForm.get('selectedInstructionSet').value"></catalog-instruction-view>
              </div>
            </div>

            <div *ngIf="progressiveInfoInstructionLoading" class="col-xs-12 flex">
              <loading class="posF vh-center" [scale]="1.5"></loading>
            </div>
          </div>
          <div class="col-xs-12">
            <label class="col-xs-4">Regimen edit reason</label>
            <div class="col-xs-12">
              <select [(ngModel)]="editReason" required="required" name="editReason">
                <option *ngFor="let reason of reasonsToEdit" value="{{reason.value}}">{{reason.display}}</option>
              </select>
            </div>
          </div>
          <div class="col-xs-12 mt-2">
              <div class="col-xs-2 flex">
                <label class="mt-0 mb-0">Voice Note</label><i class="fa fa-edit ml-3" (click)="updateVoiceNote()"></i>
              </div>
          </div>
          <div class="col-xs-12" *ngIf="antibioticsReasonRequired">
            <label class="col-xs-4">Reason For Continue Antibiotics</label>
            <div class="col-xs-12">
              <input-text [parseObj]="regimenObj" name="continueAntibioticsReason" type="string" minLength="15" required="required"></input-text>
            </div>
          </div>
          <div class="col-xs-12" *ngIf="editReason === 'OTHER'">
            <label class="col-xs-4">Regimen edit details</label>
            <div class="col-xs-8">
              <input class="form-control" type="text" [(ngModel)]="editDetails" name="editDetails" placeholder="Add details of editing reason" required="required"/>
            </div>
          </div>
          <div class="col-xs-12" *ngIf="!hideNotNecessaryThings">
            <label class="col-xs-4">Note (Not Visible To User)</label>
            <div class="col-xs-12">
              <input-textarea [parseObj]="regimenObj" name="note"></input-textarea>
            </div>
          </div>
          <div class="col-xs-12 mt-3 flex" *ngIf="!hideNotNecessaryThings">
            <div class="col-xs-6">
              <label class="col-xs-4">FixedPrice*</label>
              <div class="col-xs-7">
                <input-text [parseObj]="regimenObj" name="fixedPrice" type="number" (onValueChange)="invoiceTitleRequired = $event > 0" required="required"></input-text>
              </div>
            </div>
            <div class="col-xs-6" *ngIf="invoiceTitleRequired || currentVariantId">
              <label class="col-xs-4">Fixed Price MRP*</label>
              <div class="col-xs-7">
                <input-text [parseObj]="regimenObj" name="fixedPriceMRP" type="number" required="required"></input-text>
              </div>
            </div>
          </div>
          <div class="col-xs-12 mt-3" *ngIf="invoiceTitleRequired || currentVariantId">
            <label class="col-xs-4">FixedPrice Invoice Title</label>
            <div class="col-xs-8">
              <input-text [parseObj]="regimenObj" name="invoiceTitle" required="true"></input-text>
            </div>
          </div>
          <div class="col-xs-12 mt-3">
            <div class="col-xs-6 flex">
              <label class="col-xs-6">Total Price Before Editing Regimen</label>
              <div class="col-xs-4 flex"><span>{{priceBeforeEditing}}</span></div>
            </div>
            <div class="col-xs-6 flex">
              <label class="col-xs-6">Total Price</label>
              <div class="col-xs-4 flex"><span>{{totalPrice}}</span></div>
            </div>
          </div>
          <ng-container *ngIf="!hideNotNecessaryThings">
            <div class="col-xs-12 mt-3">
              <div class="col-xs-4">
                <label class="col-xs-6">Sample Available</label>
                <div class="col-xs-4">
                  <input-checkbox [parseObj]="regimenObj" name="sampleAvailable"></input-checkbox>
                </div>
              </div>
              <div class="col-xs-4" *ngIf="this.userRoles.includes('adminDoctor')">
                <label class="col-xs-6">Active</label>
                <div class="col-xs-4">
                  <input-checkbox [parseObj]="regimenObj" name="active"></input-checkbox>
                </div>
              </div>
              <div data-testid="dr-approved" class="col-xs-4">
                <label class="col-xs-6">Dr. Approved</label>
                <div class="col-xs-4">
                  <input-checkbox [parseObj]="regimenObj" name="doctorVerified"></input-checkbox>
                </div>
              </div>
            </div>
            <div class="col-xs-12 mt-3">
              <div class="col-xs-4">
                <label class="col-xs-6">Show Summary View</label>
                <div class="col-xs-4">
                  <input-checkbox [parseObj]="regimenObj" name="showSummaryView"></input-checkbox>
                </div>
              </div>
              <div class="col-xs-4">
                <label class="col-xs-6">Send No Message To User</label>
                <div class="col-xs-4">
                  <input-checkbox [parseObj]="regimenObj" name="noMessageToUser"></input-checkbox>
                </div>
              </div>
            </div>
            <div class="col-xs-12 mt-3" *ngIf="userRoles.includes('adminDoctor') || userRoles.includes('regimenEditor')">
              <div class="col-xs-4 flex">
                <label class="mt-0 col-xs-6">Maximum Number of Products*</label>
                <div class="col-xs-4">
                  <input-text [parseObj]="regimenObj" name="numberOfProductsLimit" type="number"></input-text>
                </div>
              </div>
              <div class="col-xs-8">
                <div class="col-xs-4 flex">
                  <label class="mt-0 col-xs-6">interval In Days*</label>
                  <div class="col-xs-4">
                    <input [(ngModel)]="followUpConfig.intervalInDays" name="intervalInDays" type="number" (ngModelChange)="updateVariantFollowUpConfig()"/>
                  </div>
                </div>
                <div class="col-xs-4 flex">
                  <label class="mt-0 col-xs-6">duration In Days*</label>
                  <div class="col-xs-4">
                    <input [(ngModel)]="followUpConfig.durationInDays" name="durationInDays" type="number" (ngModelChange)="updateVariantFollowUpConfig()"/>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
          <div class="col-xs-4 mt-2">
            <label class="col-xs-6">Treatment Scenario Tree</label>
            <div class="col-xs-4">
              <input-text type="text" [parseObj]="regimenObj" type="string" name="treatmentScenarioTree"/>
            </div>
          </div>
          <div class="col-xs-12" *ngIf="currentVariantId !== this.appConfig.Shared.Regimen.Variants.VariantId.variant_1499">
            <button (click)="copyFollowUpSop(regimenObjVariant1)">copy from variant1</button>
            <button class="ml-3" *ngIf="currentVariantId !== this.appConfig.Shared.Regimen.Variants.VariantId.variant_1999" (click)="copyFollowUpSop(regimenObjVariant2)">copy from variant2</button>
            <button class="ml-3" *ngIf="currentVariantId !== this.appConfig.Shared.Regimen.Variants.VariantId.variant_4999" (click)="copyFollowUpSop(regimenObjVariant3)">copy from variant3</button>
          </div>
          <ng-container *ngIf="regimenObj.get('type') == appConfig.Shared.Regimen.Type.MAIN || regimenObj.get('type') == appConfig.Shared.Regimen.Type.ALTERNATE">
            <div class="col-xs-12">
              <label>
                Followup SOP
                <i class="fa fa-plus-square-o ml-3" (click)="addFollowUp()"></i>
                <i class="fas fa-history ml-3" (click)="showFollowUpSopHistory()"></i>
              </label>
              <div *ngFor="let node of regimenObj.get('followUpSop');let i = index;">
                <followup-sop class="col-xs-12" [node]="node" (delete)="deleteFollowUp(i)" prefix="{{i}}" [regimenId]="regimenObj.get('regimenId')" [variantId]="this.currentVariantId"></followup-sop>
              </div>
            </div>
          </ng-container>
        </div>
      </form>
      <div class="col-xs-12 p-0" *ngIf="actionLog.length && !disableVariant">
        <div class="col-xs-12 font-bold list-header mb-2 pl-4">Change in Regimen</div>
        <div class="max-height100">
          <div class="col-xs-12 px-4 mb-2" *ngFor="let item of actionLog;">
            <div class="col-xs-4">{{item.get('Action')}}</div>
            <div class="col-xs-4">{{item.get("createdAt")}}</div>
            <div class="col-xs-4">{{item.get('ByUser') ? item.get('ByUser').get('username') : ''}}</div>
          </div>
        </div>
      </div>
      <button class="m-4" *ngIf="!showAsOfflineRegimen" (click)="saveRegimen()" [disabled]="!regimenForm.valid">{{ regimenObj?.id ? 'Update ' : 'Create' }}</button>
    </div>
    <div data-testid="create-order-modal" class="model_payment_mode" *ngIf="ui.makeBlur" (click)="ui.makeBlur = false">
      <div class="holder" (click)="stopPropagation($event)">
        <form #confirmationForm="ngForm">
          <div class="col-xs-12">
            <div class="col-xs-12 whitespace-pre-inline">{{orderConfirmationMessage}}</div>
            <div class="col-xs-12">
              <div class="m-2" *ngIf="changedProductsWhichAreAlreadyInOrdersInTransit?.length">
                <label class="alert-warning col-xs-12 m-3 breadcrumb">* Newly added products are already purchased by user and are in transit, do you still want to create order for them?</label>
                <div class="p-3" *ngIf="changedProductsWhichAreAlreadyInOrdersInTransit?.length">
                  <ul *ngFor="let product of changedProductsWhichAreAlreadyInOrdersInTransit">
                    <li>{{product.get('title')}}</li>
                  </ul>
                </div>
              </div>
              <div class="m-2" *ngIf="changedProductsWhichAreAlreadyInOrdersInDelivered?.length">
                <label class="alert-warning col-xs-12 m-3 breadcrumb">* Newly added product are already delivered to users in last 15 days, do you still want to create order for them?</label>
                <div class="p-3" *ngIf="changedProductsWhichAreAlreadyInOrdersInDelivered?.length">
                  <ul *ngFor="let product of changedProductsWhichAreAlreadyInOrdersInDelivered">
                    <li>{{product.get('title')}}</li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="col-xs-12">
              <label class="col-xs-12" style="margin-top:5px;font-weight:bold">Products</label>
              <div class="col-xs-12 no-padder">
                <div *ngFor="let product of followUpProducts;let i = index;" style="padding:3px 10px;background:#5a5a5a;display:inline-block;border-radius:3px;margin:2px 10px 2px 0px;color:white"><i class="fa fa-trash-o pointer" (click)="removeProduct(i)"></i>
                  <div style="max-width:500px;display:inline-block;">&nbsp;&nbsp; {{product.get('title')}}&nbsp;[{{product.get('quantity')}}{{product.get('quantityUnit')}}] {{product.get('type') === apiClientConstant.Catalog.Type.SAMPLE ? '(SAMPLE)' : '' }}</div>
                </div>
              </div>
              <div class="col-xs-12 no-padder">
                <input type="text" placeholder="Type Product Name..." aria-label="Number" name="add_product" autocomplete="off" matInput="matInput" [formControl]="autoCompleteProductController" [matAutocomplete]="productAuto"/>
                <mat-autocomplete class="search-bar-xs" #productAuto="matAutocomplete">
                  <mat-option *ngFor="let option of productOptions | async" [value]="option.name" (onSelectionChange)="autoCompleteProductOnSelect(option)">{{option.name}}</mat-option>
                </mat-autocomplete>
              </div>
            </div>
            <div class="col-xs-12 no-padder m-t-xs">
              <div class="col-xs-6 wrapper-sm font-bold">Select Payment Type</div>
              <div class="col-xs-6">
                <input-select [parseObj]="regimenObj" name="paymentType" [options]="paymentTypeList"></input-select>
              </div>
            </div>
            <div class="col-xs-6"><br/>
              <input-checkbox [parseObj]="regimenObj" name="followUpNeeded" title="&amp;nbsp; Instruction Call Needed"></input-checkbox>
            </div>
            <div class="col-xs-6"><br/>
              <input-checkbox [parseObj]="regimenObj" name="followUpRequired" title="&amp;nbsp; Required for next followUp"></input-checkbox>
            </div>
            <div class="col-xs-12 m-t-xs">
              <div data-testid="dont-create-order" class="pull-left btn btn-light-blue m-t-xs" (click)="saveRegimenCreatingOrder(false)">Don't Create Order</div>
              <div class="pull-right btn btn-success m-t-xs" (click)="saveRegimenCreatingOrder(true)">Create Order</div>
            </div>
          </div>
        </form>
      </div>
    </div>
    <div data-testid="in-transit-popup" class="popup m-2 p-2 scrollable" *ngIf="!isProductExistedWarningIgnored && (changedProductsWhichAreAlreadyInOrdersInTransit?.length || changedProductsWhichAreAlreadyInOrdersInDelivered?.length)">
      <div class="m-2" *ngIf="changedProductsWhichAreAlreadyInOrdersInTransit?.length">
        <label class="alert-warning col-xs-12 m-3 breadcrumb">* Newly added products are already purchased by user and are in transit, do you still want to create order for them?</label>
        <div class="p-3" *ngIf="changedProductsWhichAreAlreadyInOrdersInTransit?.length">
          <ul *ngFor="let product of changedProductsWhichAreAlreadyInOrdersInTransit">
            <li>{{product.get('title')}}</li>
          </ul>
        </div>
      </div>
      <div class="m-2" *ngIf="changedProductsWhichAreAlreadyInOrdersInDelivered?.length">
        <label class="alert-warning col-xs-12 m-3 breadcrumb">* Newly added product are already delivered to users in last 15 days, do you still want to create order for them?</label>
        <div class="p-3" *ngIf="changedProductsWhichAreAlreadyInOrdersInDelivered?.length">
          <ul *ngFor="let product of changedProductsWhichAreAlreadyInOrdersInDelivered">
            <li>{{product.get('title')}}</li>
          </ul>
        </div>
      </div>
      <div class="col-xs-10 mt-4 border flex justify-content-center">
        <button class="m-5" type="button" (click)="productExistedInPreviousOrder()">Agree to Proceed</button>
        <button class="m-5" type="button" (click)="resetPopUp()">Cancel</button>
      </div>
    </div>
  </div>
</div>
